import * as React from 'react'

function CircleCloseRedIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}>
      <g data-name="Group 52835">
        <g data-name="Group 51812">
          <g
            data-name="Ellipse 1015"
            fill="none"
            stroke="#fe5f55"
            strokeWidth={1.8}
            transform="translate(-104 -2136.401) translate(104 2136.401)"
          >
            <circle cx={10} cy={10} r={10} stroke="none" />
            <circle cx={10} cy={10} r={9.1} />
          </g>
        </g>
        <path
          d="M1.273 9.68L3.84 7.113 1.307 4.58l1.264-1.264L5.1 5.849l2.538-2.533L8.9 4.58 6.369 7.113l2.5 2.5L7.6 10.876l-2.5-2.5-2.563 2.569z"
          transform="translate(-104 -2136.401) translate(108.728 2139.271)"
          fill="#fe5f55"
        />
      </g>
    </svg>
  )
}

export default CircleCloseRedIcon
